// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__La71U","ant-page-header-heading-title":"styles_ant-page-header-heading-title__yHi0-","table":"styles_table__KWU4v"};